import { useMemo } from 'react';

import { keyOf, Toggle } from '@Components/Grid/components/Table/formatters';
import column, { defaultActionsColumn, deleteAction, editAction } from '@Components/Grid/utils/column';

import GlobalToggle from './GlobalToggle';
import RedirectFormatter from './RedirectFormatter';
import SortActionsFormatter from './SortActionsFormatter';

export default function useColumns() {
  return useMemo(() => [
    column.accessor('sortAction', {
      header: '',
      enableSorting: false,
      cell: info => <SortActionsFormatter info={info} />,
      initialSize: 'w-[5vw]',
      enableColumnResize: false,
    }),
    column.accessor('id', {
      header: '#',
      enableSorting: false,
      maxSize: 60,
    }),
    column.accessor('value', {
      header: 'Value',
      enableSorting: false,
      enableTruncateTooltip: true,
    }),
    column.accessor('redirect_url', {
      header: 'Redirect',
      enableSorting: false,
      cell: info => <RedirectFormatter info={info} />,
      enableTruncateTooltip: true,
    }),
    column.accessor('type', {
      header: 'Type',
      enableSorting: false,
      enableTruncate: true,
    }),
    column.accessor('active', {
      header: 'Active',
      enableSorting: false,
      cell: info => <Toggle key={keyOf(info)} info={info} />,
      enableColumnResize: false,
    }),
    column.accessor('global', {
      header: 'Global',
      enableSorting: false,
      cell: info => <GlobalToggle key={keyOf(info)} info={info} />,
      enableColumnResize: false,
    }),
    defaultActionsColumn(editAction, deleteAction),
  ], [])
}
